// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"24":"597e650ae4aacdcf","519":"8c360070fcd9ba13","876":"b47d25ce17e344f0"}[chunkId] + "";
};